var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.9,
    height: 46,
    viewBox: "0 0 40.9 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3395",
    "data-name": "Group 3395",
    transform: "translate(407.039 -187.971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4748",
    "data-name": "Path 4748",
    d: "M-369.944,209.013V187.978h-2.6v2.557H-400.7v-2.564h-2.558V209h2.605v-6.954H-372.5v6.969Zm-15.227,11.354c.921.544,1.76,1.019,2.575,1.532a.655.655,0,0,0,.786-.009c2.883-1.664,5.814-3.249,8.647-4.992a7.009,7.009,0,0,1,4.785-1.264.355.355,0,0,0,.055,0,2.179,2.179,0,0,0,2.115-2.748,2.144,2.144,0,0,0-2.373-1.671H-392.7c-4.066,0-8.132-.007-12.2.008a2.084,2.084,0,0,0-2.138,2.217,2.116,2.116,0,0,0,2.173,2.193c.641.006,1.286-.039,1.922.016a3.07,3.07,0,0,1,1.23.331q13.97,7.952,27.921,15.938c1,.572,1.993,1.157,3,1.713a1.44,1.44,0,0,0,1.773-.2,1.372,1.372,0,0,0,.276-1.707,2.808,2.808,0,0,0-.927-.815q-13.015-7.47-26.044-14.916c-.162-.093-.321-.191-.576-.344H-377.1l.019.087Zm-2.8,5.008c-.96-.563-1.85-1.1-2.757-1.6a.589.589,0,0,0-.485.042q-6.438,3.706-12.863,7.436a1.417,1.417,0,0,0-.551,1.99,1.456,1.456,0,0,0,2.044.509q6.71-3.839,13.418-7.681C-388.785,225.853-388.41,225.632-387.969,225.376Z",
    transform: "translate(0)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4749",
    "data-name": "Path 4749",
    d: "M-339.335,209.013h-2.552v-6.969h-28.158V209h-2.605V187.971h2.558v2.564h28.158v-2.557h2.6Z",
    transform: "translate(-30.609)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4750",
    "data-name": "Path 4750",
    d: "M-385.171,408.553l8.093-4.631-.019-.087h-19.192c.254.152.413.251.576.344q13.024,7.454,26.044,14.916a2.807,2.807,0,0,1,.927.815,1.372,1.372,0,0,1-.276,1.707,1.44,1.44,0,0,1-1.773.2c-1.009-.556-2-1.141-3-1.713q-13.957-7.975-27.921-15.938a3.07,3.07,0,0,0-1.23-.331c-.636-.055-1.281-.009-1.922-.016a2.116,2.116,0,0,1-2.173-2.193,2.084,2.084,0,0,1,2.138-2.217c4.066-.015,8.132-.008,12.2-.008h24.122a2.144,2.144,0,0,1,2.373,1.671,2.179,2.179,0,0,1-2.115,2.748.351.351,0,0,1-.055,0,7.009,7.009,0,0,0-4.785,1.264c-2.834,1.743-5.764,3.328-8.647,4.992a.655.655,0,0,1-.786.009C-383.411,409.572-384.25,409.1-385.171,408.553Z",
    transform: "translate(0 -188.186)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4751",
    "data-name": "Path 4751",
    d: "M-370.085,514.968c-.44.256-.815.477-1.193.693q-6.709,3.841-13.418,7.681a1.456,1.456,0,0,1-2.044-.509,1.417,1.417,0,0,1,.551-1.99q6.425-3.729,12.863-7.436a.589.589,0,0,1,.485-.042C-371.935,513.87-371.044,514.4-370.085,514.968Z",
    transform: "translate(-17.884 -289.592)",
    fill: "#febaba"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChair);
export default __webpack_public_path__ + "static/media/chair.8fe077e0c9586b0e86b0fdd98ee93268.svg";
export { ForwardRef as ReactComponent };